var Barometer = new Class({
	Implements: [Options],

	options: {
		areaSelector: 'map area',
		hoverSelector: 'ul li',
		popupSelector: 'table',
		overlaySelector: '.overlay',
		hoverClass: 'hover',
		popupClass: 'shown',
		ga_tracker: null,
		ga_category: 'Barometer',
		ga_actions: {
			show: 'Gegevens bekijken',
			click: 'Barometer bekijken'
		},
		ga_actions_delay: {}
	},

	trackEventTimer: {},

	initialize: function (element, options) {
		this.element = document.id(element);
		this.setOptions(options);

		this.hovers = this.element.getElements(this.options.hoverSelector);
		this.popups = this.element.getElements(this.options.popupSelector);
		this.overlay = this.element.getElement(this.options.overlaySelector);

		this.setup();
	},

	setup: function () {
		this.element.addEvent('mouseenter:relay(' + this.options.areaSelector + ')', this.show.bind(this));
		this.element.addEvent('mouseleave:relay(' + this.options.areaSelector + ')', this.hide.bind(this));

		if (this.overlay && this.overlay.getElement('a')) {
			this.element.addClass('has-overlay').addEvents({
				'mouseenter': function () {
					this.overlay.addClass('shown');
				} .bind(this),
				'mouseleave': function () {
					this.overlay.removeClass('shown');
				} .bind(this),
				'click': function () {
					this.trackEvent('click');
					window.document.location = this.overlay.getElement('a').href;
				} .bind(this)
			});
		}
	},

	show: function (e) {
		var area = document.id(e.target);
		var className = area.get('class');

		// Show hovers
		this.getHovers(className).addClass(this.options.hoverClass);

		// Show popups
		this.getPopups(className).addClass(this.options.popupClass);

		// Track event
		this.trackEvent('show', area.get('alt'));
	},

	hide: function (e) {
		var area = document.id(e.target);
		var className = area.get('class');

		// Hide hovers
		this.getHovers(className).removeClass(this.options.hoverClass);

		// Hide popups
		this.getPopups(className).removeClass(this.options.popupClass);

		// Clear event tracker timeout
		this.clearTrackEvent('show');
	},

	getHovers: function (className) {
		return this.hovers.filter(function (hover) {
			return hover.hasClass(className);
		});
	},

	getPopups: function (className) {
		return this.popups.filter(function (popup) {
			return popup.hasClass(className);
		});
	},

	trackEvent: function (action, opt_label, opt_value) {
		if (this.options.ga_tracker) {
			this.clearTrackEvent(action);
			this.trackEventTimer[action] = this.options.ga_tracker._trackEvent.delay(this.options.ga_actions_delay[action] || 0, this.options.ga_tracker, [this.options.ga_category, this.options.ga_actions[action], opt_label, opt_value]);
		}
	},

	clearTrackEvent: function (action) {
		clearTimeout(this.trackEventTimer[action]);
	}
});